import type { MechKey } from './keys';

export const te: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'యాంత్రిక శాస్త్రం · 2D',
  'panel.scene': 'సన్నివేశం',
  'panel.dims': 'పారామితులు',
  'panel.style': 'రూపం',
  'panel.action': 'నియంత్రణలు',
  'style.body': 'వస్తువు',
  'style.vector': 'సదిశలు',
  'style.ground': 'నేల',
  'style.forces': 'బలాలను చూపించు',
  'style.trace': 'మార్గాన్ని చూపించు',
  'style.labels': 'సదిశ లేబుళ్ళు',
  'hint.line1': 'ప్రారంభించడానికి ప్లే నొక్కండి · వస్తువులను లాగి తరలించండి',
  'hint.line2': 'శాండ్‌బాక్స్: ఒక ఆకారాన్ని ఎంచుకోండి, తర్వాత ఉంచడానికి క్లిక్ చేయండి',
  'scene.incline': 'వాలు తలం',
  'scene.projectile': 'ప్రక్షేపక గమనం',
  'scene.pendulum': 'లోలకం',
  'scene.springMass': 'స్ప్రింగ్-ద్రవ్యరాశి వ్యవస్థ',
  'scene.collisions': 'ఢీకొనడాలు',
  'scene.atwood': 'అట్‌వుడ్ యంత్రం',
  'scene.circular': 'వృత్తాకార గమనం',
  'scene.sandbox': 'శాండ్‌బాక్స్',
  'dim.angle': 'కోణం (°)',
  'dim.friction': 'ఘర్షణ',
  'dim.mass': 'ద్రవ్యరాశి',
  'dim.massA': 'ద్రవ్యరాశి A',
  'dim.massB': 'ద్రవ్యరాశి B',
  'dim.velocity': 'వేగం',
  'dim.angleLaunch': 'ప్రక్షేపణ కోణం (°)',
  'dim.gravity': 'గురుత్వాకర్షణ',
  'dim.gravityX': 'గురుత్వాకర్షణ x',
  'dim.gravityY': 'గురుత్వాకర్షణ y',
  'dim.length': 'పొడవు',
  'dim.damping': 'అవమందన',
  'dim.spring': 'దృఢత',
  'dim.restitution': 'పునరుద్ధరణ',
  'dim.radius': 'వ్యాసార్థం',
  'dim.speed': 'వేగమాత్ర',
  'action.play': 'ప్లే',
  'action.pause': 'పాజ్',
  'action.step': 'దశ',
  'action.reset': 'రీసెట్',
  'action.speed': 'వేగం',
  'action.clear': 'తొలగించు',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'గురుత్వాకర్షణ',
  'forceName.normal': 'అభిలంబ బలం',
  'forceName.friction': 'ఘర్షణ బలం',
  'forceName.tension': 'తన్యత',
  'forceName.spring': 'స్ప్రింగ్ బలం',
  'forceName.applied': 'ఆరోపిత బలం',
  'forceName.air': 'వాయు నిరోధం',
  'palette.box': 'పెట్టె',
  'palette.circle': 'బంతి',
  'palette.ramp': 'వాలు',
  'palette.ground': 'నేల',
  'palette.hint': 'ఒక ఆకారాన్ని ఎంచుకోండి, తర్వాత ఉంచడానికి కాన్వాస్‌పై క్లిక్ చేయండి.',
  'panel.forces': 'గమనించిన బలాలు',
  'forces.empty': 'ఇంకా ఏమీ లేదు — సన్నివేశాన్ని ప్లే చేయండి',
};
